import React from 'react';
import { BaseFilterRadioSelect } from '../base/BaseFilterRadioSelect';
import { ISelectOption } from '../../../domain/saved-filters/interface';

interface IPjmRegistrationCompletedFilterSelectProps {
    value: string | null;
    onChange: (value: string | null) => void;
    label?: string;
    height?: number;
    searchable?: boolean;
    disabled?: boolean;
    resizable?: boolean;
    options: ISelectOption<string>[];
    isLoading?: boolean;
}

export const PjmRegistrationCompletedFilterSelect: React.FC<IPjmRegistrationCompletedFilterSelectProps> = ({
    value,
    onChange,
    label,
    height = 90,
    disabled = false,
    options,
    isLoading,
}) => {
    return (
        <BaseFilterRadioSelect
            resizable
            showClear={false}
            selectedCountInLabel
            disabled={disabled}
            options={options}
            value={value}
            onChange={onChange}
            loading={isLoading}
            label={label}
            height={height}
        />
    );
};
